import { render, staticRenderFns } from "./SignTodoCount.vue?vue&type=template&id=0a57d8a0&scoped=true"
import script from "./SignTodoCount.vue?vue&type=script&lang=js"
export * from "./SignTodoCount.vue?vue&type=script&lang=js"
import style0 from "./SignTodoCount.vue?vue&type=style&index=0&id=0a57d8a0&prod&lang=scss&scoped=true"
import style1 from "./SignTodoCount.vue?vue&type=style&index=1&id=0a57d8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a57d8a0",
  null
  
)

export default component.exports